import { ContainerModule } from 'inversify';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';

export const eventStreamModule = new ContainerModule((bind) => {
  bind<EventStream>(EventStreamSymbol).to(EventStream).inSingletonScope();
});
